var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangementBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: #4970b6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.52 42.87 87.52 77.77 94.27 77.77 94.27 42.87 102.81 42.87 96.86 32.55 90.9 22.23 84.94 32.55 78.99 42.87 87.52 42.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.18,78.68h-8.56v-34.91h-9.2l13.48-23.36,13.49,23.36h-9.21v34.91ZM88.43,76.87h4.94v-34.91h7.88l-10.34-17.91-10.34,17.91h7.87v34.91Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "62.48 57.15 62.48 22.23 55.72 22.23 55.72 57.15 47.19 57.15 53.14 67.46 59.1 77.77 65.05 67.46 71.01 57.15 62.48 57.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.1,79.59l-13.48-23.35h9.2V21.33h8.57v34.91h9.19l-13.48,23.35ZM48.76,58.05l10.34,17.91,10.34-17.91h-7.87V23.14h-4.94v34.91h-7.87Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangementBleu);
export default __webpack_public_path__ + "static/media/changement_bleu.b6c352c7ad983a3a158555ea5f0a015e.svg";
export { ForwardRef as ReactComponent };